import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";
import "./bootstrap.min.css";
import Container from "./layouts/Container";

function App() {
  return (
    <>
      <Container />
      <ToastContainer />
    </>
  );
}

export default App;
